export default {
    priority: {
        low: 'Baja',
        normal: 'Normal',
        high: 'Alta',
        urgent: 'Urgente',
    },
    priority_integer: {
        4: 'Baja',
        3: 'Normal',
        2: 'Alta',
        1: 'Urgente',
    },
    attendance_type_status: {
        start: 'En Proceso',
        finish: 'Concluido',
        pause: 'En Pausa',
        idle: 'Ninguna Acción',
    },
    taskier_documents: {
        privacy_policy: 'Política de privacidad',
        terms_of_use: 'Terminos de uso',
    },
    service_chat_status: {
        'in-progress': 'En Proceso',
        waiting: 'En espera',
        unanswered: 'Sin Respuesta',
        finished: 'Terminado',
    },
    holiday_scope: {
        municipal: 'Municipal',
        state: 'Estatal',
        federal: 'Federal',
    },
    user_type: {
        admin: 'Administrador',
        agent: 'Agente',
        customer: 'Cliente',
        'guest-email': 'E-mail',
    },
    task_status: {
        open: 'En Proceso',
        paused: 'En Pausa',
        done: 'Concluido',
    },
    deadline_status: {
        overdue: 'Tarde',
        'on-schedule': 'Al Dia',
        'no-deadline': 'Sin Fecha Límite',
    },
    article_status: {
        published: 'Publicado',
        'in-review': 'En Revisión',
    },
    tenant_subscription_status: {
        active: 'Activo',
        overdue: 'Pago Tardío',
        trialing: 'Periodo de Prueba',
        canceled: 'Cancelado',
    },
    tenant_payment_status: {
        confirmed: 'Confirmado',
        pending: 'Aguardando Pagamento',
        received: 'Recibió',
        overdue: 'Vencido',
        refunded: 'Reembolsado',
        refund_requested: 'Reembolsado Requerido',
        chargeback_requested: 'Chargeback Requerido',
    },
    connection_status: {
        success: 'Conectado',
        failed: 'Problema de conexión',
    },
}
